"use client";
import {useRoutePlan} from "@/context/routePlan/optimizer/routePlanVariant";
import {Accordion, AccordionItem} from "@nextui-org/react";
import {useState} from "react";
import {FiSidebar} from "react-icons/fi";
import {HiOutlineClock} from "react-icons/hi";
import {InputParammeter} from "./inputParamerter";
export const LeftRoutePlan = ({
  setIsHistoryTab
}: {
  setIsHistoryTab: (val: boolean) => void;
}) => {
  const [isLeftDrawerOpen, setIsLeftDrawerOpen] = useState(true);
  const {planId, routePlanItem} = useRoutePlan();

  return (
    <>
      <div className="absolute left-4 top-2 z-10 w-96 rounded bg-white bg-opacity-90 p-2 shadow-md">
        <div className="flex items-center justify-between border-b px-4 py-2">
          {/* Title */}
          <h2 className="text-sm font-semibold text-gray-700">
            {routePlanItem ? routePlanItem.planName : `Plan ID: ${planId}`}
          </h2>

          {/* Action Icons */}
          <div className="flex items-center space-x-3">
            <button
              title="View History"
              className="text-gray-600 hover:text-gray-800"
              onClick={() => setIsHistoryTab(true)}
            >
              <HiOutlineClock className="h-5 w-5" />
            </button>
            <button
              title="Open Drawer"
              className="text-gray-600 hover:text-gray-800"
              onClick={() => setIsLeftDrawerOpen(!isLeftDrawerOpen)}
            >
              <FiSidebar className="h-5 w-5" />
            </button>
          </div>
        </div>
        {isLeftDrawerOpen && (
          <div className="flex flex-col">
            <div className="p-2">
              {/* Drawer content here */}
              <Accordion
                variant="bordered"
                //selectionMode="multiple"
                isCompact
                className="w-full"
                defaultExpandedKeys={["1"]}
              >
                <AccordionItem
                  key="1"
                  aria-label="Input Parameters"
                  title="Input Parameters"
                >
                  <div className="flex flex-col">
                    <div className="max-h-[350px] space-y-4 overflow-y-auto pr-2">
                      <InputParammeter setIsHistoryTab={setIsHistoryTab} />
                    </div>
                  </div>
                </AccordionItem>
                {/* <AccordionItem
                  key="2"
                  aria-label="Output Results"
                  title="Output Results"
                >
                  <div className="max-h-[350px] space-y-4 overflow-y-auto pr-2">
                  <OutputResult />
                  </div
                </AccordionItem> */}
              </Accordion>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
